import { type BeforeRetryHook, type BeforeRetryState, HTTPError } from "ky";

import { AUTH_TOKEN_KEY } from "../../../constants";
import { getMyToken } from "../../auth";

const AUTH_ERROR_REDIRECT_URL = "/oops";
const MAX_RETRIES = 5;

/**
 * If we have an auth error, pull a new token
 * and use that before retrying.
 */
export const getTokenIfPermissionsError: BeforeRetryHook = async (data) => {
  // If we're already on the auth error page, don't try to get a new token
  if (window.location.pathname === AUTH_ERROR_REDIRECT_URL) {
    return;
  }

  // Only try to get a new token up to MAX_RETRIES times
  if (data.retryCount >= MAX_RETRIES) {
    return;
  }

  // If it's not an authorization error, don't try to get a new token
  if (!isAuthorizationError(data)) {
    return;
  }

  const token = await getMyToken();

  if (token) {
    window.localStorage.setItem(AUTH_TOKEN_KEY, token);
  } else {
    window.location.assign(AUTH_ERROR_REDIRECT_URL);
    return;
  }
};

function isAuthorizationError(data: BeforeRetryState) {
  return data.error instanceof HTTPError && data.error.response?.status === 401;
}
